import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchProduct = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/products/${id}`).then(product => {
    dispatch({
      type: types.FETCH_INGREDIENT,
      payload: {
        product,
      },
    });

    return product;
  });
